import React from 'react';
import autobind from 'autobind';

import { Scroller } from '@components/Scroller';

export interface WithScrollPageContentProps {
    onWheel(e: React.WheelEvent): void;
    onScroll(): void;
}

export function scrollPageContentHOC<Props>(WrappedComponent: any): React.ComponentClass<Props> {
    class ScrollPageContentHOC extends React.Component<Props> {
        private isOnScroll: boolean = false;
        private timeoutId?: NodeJS.Timeout;

        public render(): React.ReactNode {
            return React.createElement(WrappedComponent, {
                ...this.props,
                onScroll: this.handleScroll,
                onWheel: this.handleWheel,
            });
        }

        @autobind
        protected handleScroll() {
            this.isOnScroll = true;

            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }

            this.timeoutId = setTimeout(() => {
                this.isOnScroll = false;
            }, 300);
        }

        @autobind
        protected handleWheel(e: React.WheelEvent) {
            if (!this.isOnScroll) {
                Scroller.scrollMore(e.deltaY);
            }
        }
    }

    return ScrollPageContentHOC;
}
